import { render, staticRenderFns } from "./PlatFormGraph.vue?vue&type=template&id=0bead478&scoped=true&"
import script from "./PlatFormGraph.vue?vue&type=script&lang=js&"
export * from "./PlatFormGraph.vue?vue&type=script&lang=js&"
import style0 from "./PlatFormGraph.vue?vue&type=style&index=0&id=0bead478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bead478",
  null
  
)

export default component.exports